import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SSTService {
    constructor(private httpClient: HttpClient) { }

    /**
     * function checks if Self service tab exist for this reseach module
     * @param researchModuleId research module id
     */
    checkSSTExist(researchModuleId: string) {
        return this.httpClient.get(`SelfServiceTabs/is-exist?researchDocumentId=${researchModuleId}`);
    }

    getSSTById(researchModuleId: string) {
        return this.httpClient.get(`SSTViews/fetch/${researchModuleId}`);
    }

    graphDetails(graphData) {
        return this.httpClient.post("MarketData/create", graphData);
    }

    responseList(questionId: any) {
      return this.httpClient.get(`GraphTypes/graph-generation-dashboard/survey-questions/response?questionId=${questionId}`);
    }

    saveGraph(graphData: any) {
        return this.httpClient.post(`SSTMyGraphs/save`,graphData);
    }
    getSSTGraphData(data: any){
        return this.httpClient.get(`SSTMyGraphs/get-list?researchDocumentId=${data.docId}&limit=${data.limit}
            &skip=${data.skip}`);
    }
    getSSTQuestionYaxisFilterQuestions(xAxisQuestionId){
        return this.httpClient.get(`SSTQuestions/get-list?xAxisQuestionId=${xAxisQuestionId}`);
    }
}


// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/self-service-tab.service.ts